module.exports = __webpack_public_path__ + "static/media/learn-spanish.fe31aa44.jpg";